import MobileNav from './header/mobile-nav';
import Search from './components/block-search';
import HandleVideosPlayDisplay from './components/paragraph-video';
import animateElements from './components/animation';

MobileNav();
Search();
HandleVideosPlayDisplay();
animateElements();
